(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fashion-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-fashion-hero-carousel]');
    if (!root) return;

    const track = root.querySelector('[data-carousel-track]');
    const slides = [...root.querySelectorAll('[data-carousel-slide]')];
    const dots = [...root.querySelectorAll('[data-carousel-dot]')];
    const viewport = root.querySelector('[data-carousel-viewport]');
    const intervalMs = Math.max(3000, Number(root.dataset.interval) || 5000);
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!track || slides.length < 2) return;

    let index = 0;
    let timer = null;
    let paused = false;

    const setActive = (nextIndex) => {
      index = (nextIndex + slides.length) % slides.length;
      track.style.transform = `translate3d(-${index * 100}%, 0, 0)`;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
    };

    const go = (delta) => {
      setActive(index + delta);
      restartAutoplay();
    };

    const tick = () => {
      if (paused || document.hidden) return;
      setActive(index + 1);
    };

    const clearTimer = () => {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    };

    const startAutoplay = () => {
      clearTimer();
      if (reduceMotion) return;
      timer = window.setInterval(tick, intervalMs);
    };

    const restartAutoplay = () => {
      clearTimer();
      startAutoplay();
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const i = Number(dot.dataset.index);
        if (!Number.isNaN(i)) {
          setActive(i);
          restartAutoplay();
        }
      });
    });

    if (viewport) {
      let touchStartX = 0;
      let touchStartY = 0;
      let touchTracking = false;

      viewport.addEventListener(
        'touchstart',
        (event) => {
          if (event.touches.length !== 1) return;
          touchStartX = event.touches[0].clientX;
          touchStartY = event.touches[0].clientY;
          touchTracking = true;
          clearTimer();
        },
        { passive: true }
      );

      viewport.addEventListener(
        'touchend',
        (event) => {
          if (!touchTracking) return;
          touchTracking = false;
          const touch = event.changedTouches[0];
          if (!touch) {
            restartAutoplay();
            return;
          }
          const deltaX = touch.clientX - touchStartX;
          const deltaY = touch.clientY - touchStartY;
          const minSwipe = 40;
          if (Math.abs(deltaX) < minSwipe || Math.abs(deltaX) <= Math.abs(deltaY)) {
            restartAutoplay();
            return;
          }
          go(deltaX < 0 ? 1 : -1);
        },
        { passive: true }
      );
    }

    root.addEventListener('mouseenter', () => {
      paused = true;
    });
    root.addEventListener('mouseleave', () => {
      paused = false;
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        clearTimer();
        return;
      }
      restartAutoplay();
    });

    if (reduceMotion) {
      track.style.transition = 'none';
    }

    setActive(0);
    startAutoplay();

    root.addEventListener('fashion-hero-carousel:destroy', clearTimer);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fashion-home-favorites"] && !Shopify.designMode) return;
  try {
    
(function () {
  const initHomeFavorite = (root) => {
    const media = JSON.parse(root.querySelector('[data-favorites-media-json]')?.textContent || '[]');
    const variants = JSON.parse(root.querySelector('[data-favorites-variants-json]')?.textContent || '[]');
    const mainImg = root.querySelector('[data-favorites-main-img]');
    const mainLink = root.querySelector('[data-favorites-main-link]');
    const titleLink = root.querySelector('[data-favorites-title-link]');
    const cta = root.querySelector('[data-favorites-cta]');
    const priceEl = root.querySelector('[data-manay-current-price]');
    const referenceEl = root.querySelector('[data-manay-reference-price]');
    const thumbsRoot = root.querySelector('[data-favorites-thumbs]');
    const colorInputs = [...root.querySelectorAll('[data-favorites-color]')];
    const sizeInputsAll = [...root.querySelectorAll('[data-favorites-size]')];
    const variantIdInput = root.querySelector('[data-favorites-variant-id]');
    const cartErrorEl = root.querySelector('[data-favorites-cart-error]');
    const cartForm = root.querySelector('.by-fashion-favorites__cart-form-inner');
    const sectionEl = root.closest('[data-favorites-cart-messages]');
    const cartMessages = (sectionEl?.dataset.favoritesCartMessages || '').split('|');
    const msgSelectColor = cartMessages[0] || 'Selecciona un color para añadir al carrito.';
    const msgSelectSize = cartMessages[1] || 'Selecciona una talla para añadir al carrito.';
    const msgUnavailable = cartMessages[2] || 'Esta combinación no está disponible.';

    const selectedColorInput = () => colorInputs.find((i) => i.checked);
    const selectedColor = () => selectedColorInput()?.value;
    const selectedSize = () =>
      [...root.querySelectorAll('[data-favorites-size]:not(:disabled)')].find((i) => i.checked)?.value;

    const colorLabelToToken = (colorName) => {
      const n = (colorName || '').toLowerCase().trim();
      if (!n) return '';
      if (n.includes('marrón chocolate') || n.includes('marron chocolate')) return 'chocolate';
      if (n.includes('chocolate')) return 'chocolate';
      if (n.includes('burdeos')) return 'burdeos';
      if (n.includes('beige')) return 'beige';
      if (n.includes('marrón') || n.includes('marron')) return 'marron';
      if (n.includes('blanco')) return 'blanco';
      if (n.includes('verde')) return 'verde';
      if (n.includes('negro')) return 'negro';
      if (n.includes('gris')) return 'gris';
      return n.normalize('NFD').replace(/\p{M}/gu, '').replace(/\s+/g, '-');
    };

    const mediaForColor = (colorName) => {
      if (!colorName) return media;
      const input = colorInputs.find((i) => i.value === colorName) || selectedColorInput();
      const swatchToken = input?.dataset.colorToken || '';
      const needle = colorLabelToToken(colorName);
      const tokenCandidates = new Set([swatchToken, needle, needle.split('-')[0]].filter(Boolean));

      let filtered = media.filter((m) => m.token && tokenCandidates.has(m.token));
      if (!filtered.length) {
        filtered = media.filter((m) => {
          const alt = (m.alt || '').toLowerCase();
          return alt.includes(needle) || alt.includes((colorName || '').toLowerCase());
        });
      }
      return filtered;
    };

    const findVariant = () => {
      const color = selectedColor();
      const size = selectedSize();
      return (
        variants.find((v) => v.color === color && v.size === size && v.available) ||
        variants.find((v) => v.color === color && v.size === size) ||
        variants.find((v) => v.color === color && v.available) ||
        variants.find((v) => v.available) ||
        variants[0]
      );
    };

    const strictSelectedVariant = () => {
      const requiresSelection = root.dataset.requiresVariantSelection === 'true';
      if (!requiresSelection) {
        return variants.find((v) => v.available) || variants[0] || null;
      }
      const needsColor = root.dataset.requiresColor === 'true';
      const needsSize = root.dataset.requiresSize === 'true';
      const color = selectedColor();
      const size = selectedSize();
      if (needsColor && !color) return null;
      if (needsSize && !size) return null;
      return variants.find((v) => v.color === color && v.size === size) || null;
    };

    const clearCartError = () => {
      if (!cartErrorEl) return;
      cartErrorEl.textContent = '';
      cartErrorEl.classList.add('hidden');
    };

    const showCartError = (message, focusTarget) => {
      if (cartErrorEl) {
        cartErrorEl.textContent = message;
        cartErrorEl.classList.remove('hidden');
      }
      const focusInput = focusTarget?.querySelector('input:not(:disabled)');
      if (focusInput instanceof HTMLElement) {
        focusInput.focus({ preventScroll: true });
      }
    };

    const setMain = (item) => {
      if (!item || !mainImg) return;
      mainImg.src = item.src;
      mainImg.removeAttribute('srcset');
      mainImg.removeAttribute('sizes');
      mainImg.alt = item.alt || '';
    };

    const renderThumbs = (items) => {
      if (!thumbsRoot) return;
      thumbsRoot.innerHTML = '';
      items.forEach((item, index) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'by-fashion-favorites__thumb' + (index === 0 ? ' is-active' : '');
        btn.setAttribute('aria-label', item.alt || 'Miniatura');
        const img = document.createElement('img');
        img.src = item.thumb;
        img.alt = '';
        img.loading = 'lazy';
        btn.appendChild(img);
        btn.addEventListener('click', () => {
          thumbsRoot.querySelectorAll('.by-fashion-favorites__thumb').forEach((el) => el.classList.remove('is-active'));
          btn.classList.add('is-active');
          setMain(item);
        });
        thumbsRoot.appendChild(btn);
      });
    };

    const syncSizeAvailability = () => {
      const color = selectedColor();
      root.querySelectorAll('[data-favorites-size]').forEach((input) => {
        const size = input.value;
        const variant = variants.find((v) => v.color === color && v.size === size);
        const available = Boolean(variant?.available);
        input.disabled = !available;
        input.closest('.by-fashion-favorites__size')?.classList.toggle('is-unavailable', !available);
        if (!available && input.checked) input.checked = false;
      });
      if (!root.querySelector('[data-favorites-size]:checked:not(:disabled)')) {
        const first = root.querySelector('[data-favorites-size]:not(:disabled)');
        if (first) first.checked = true;
      }
    };

    const syncVariant = () => {
      syncSizeAvailability();
      const variant = findVariant();
      if (!variant) return;
      const url = variant.url || root.dataset.productUrl;
      if (cta) cta.href = url;
      if (mainLink) mainLink.href = url;
      if (titleLink) titleLink.href = url;
      if (priceEl && variant.price) priceEl.textContent = variant.price;
      if (referenceEl && variant.referencePrice) referenceEl.textContent = variant.referencePrice;
      const strict = strictSelectedVariant();
      if (variantIdInput && strict?.id) variantIdInput.value = String(strict.id);
    };

    const syncColor = () => {
      const color = selectedColor();
      const items = mediaForColor(color);
      renderThumbs(items);
      if (items[0]) setMain(items[0]);
      syncVariant();
    };

    const onColorChange = (input) => {
      if (!(input instanceof HTMLInputElement) || !input.matches('[data-favorites-color]')) return;
      colorInputs.forEach((el) => {
        el.checked = el === input;
      });
      syncColor();
    };

    const onSizeChange = (input) => {
      if (!(input instanceof HTMLInputElement) || !input.matches('[data-favorites-size]') || input.disabled) {
        return;
      }
      root.querySelectorAll('[data-favorites-size]').forEach((el) => {
        if (!el.disabled) el.checked = el === input;
      });
      syncVariant();
    };

    root.addEventListener('change', (event) => {
      const target = event.target;
      if (target instanceof HTMLInputElement && target.matches('[data-favorites-color]')) onColorChange(target);
      if (target instanceof HTMLInputElement && target.matches('[data-favorites-size]')) onSizeChange(target);
    });

    const preventFocusScroll = (event) => {
      const label = event.target.closest('.by-fashion-favorites__size');
      if (!label || !root.contains(label)) return;
      event.preventDefault();
    };

    root.addEventListener('mousedown', preventFocusScroll, true);
    root.addEventListener('pointerdown', preventFocusScroll, true);

    root.addEventListener('click', (event) => {
      const sizeLabel = event.target.closest('.by-fashion-favorites__size');
      if (sizeLabel && root.contains(sizeLabel)) {
        event.preventDefault();
        const input = sizeLabel.querySelector('[data-favorites-size]');
        if (input instanceof HTMLInputElement) onSizeChange(input);
        return;
      }
      const colorLabel = event.target.closest('.by-fashion-favorites__swatch-label');
      if (colorLabel && root.contains(colorLabel)) {
        event.preventDefault();
        const input = colorLabel.querySelector('[data-favorites-color]');
        if (input instanceof HTMLInputElement) onColorChange(input);
      }
    });

    if (cartForm) {
      cartForm.addEventListener(
        'submit',
        (event) => {
          clearCartError();
          const needsColor = root.dataset.requiresColor === 'true';
          const needsSize = root.dataset.requiresSize === 'true';
          if (needsColor && !selectedColor()) {
            event.preventDefault();
            event.stopImmediatePropagation();
            showCartError(msgSelectColor, root.querySelector('.by-fashion-favorites__option'));
            return;
          }
          if (needsSize && !selectedSize()) {
            event.preventDefault();
            event.stopImmediatePropagation();
            showCartError(
              msgSelectSize,
              sizeInputsAll[0]?.closest('.by-fashion-favorites__option') || root.querySelector('.by-fashion-favorites__option')
            );
            return;
          }
          const variant = strictSelectedVariant();
          if (!variant) {
            event.preventDefault();
            event.stopImmediatePropagation();
            showCartError(msgUnavailable, root.querySelector('.by-fashion-favorites__option'));
            return;
          }
          if (!variant.available) {
            event.preventDefault();
            event.stopImmediatePropagation();
            showCartError(msgUnavailable, sizeInputsAll[0]?.closest('.by-fashion-favorites__option'));
            return;
          }
          if (variantIdInput) variantIdInput.value = String(variant.id);
        },
        true
      );
    }

    root.addEventListener('change', clearCartError);
    syncColor();
  };

  document.querySelectorAll('[data-home-favorites-item]').forEach(initHomeFavorite);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fashion-home-promo"] && !Shopify.designMode) return;
  try {
    
(function () {
  const section = document.querySelector('[data-promo-section]');
  if (!section || section.classList.contains('by-fashion-promo--ended')) return;

  const root = section.querySelector('[data-promo-countdown]');
  if (!root) return;

  const hoursEl = root.querySelector('[data-promo-hours]');
  const minutesEl = root.querySelector('[data-promo-minutes]');
  const secondsEl = root.querySelector('[data-promo-seconds]');

  const durationHours = Number(section.dataset.promoCountdownHours) || 10;
  const durationMs = durationHours * 60 * 60 * 1000;
  let endAtMs = Date.now() + durationMs;
  let wasHidden = false;

  const pad = (n) => String(n).padStart(2, '0');

  const resetCountdown = () => {
    endAtMs = Date.now() + durationMs;
    tick();
  };

  const tick = () => {
    const diffMs = endAtMs - Date.now();
    if (diffMs <= 0) {
      resetCountdown();
      return;
    }
    const totalSeconds = Math.floor(diffMs / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    if (hoursEl) hoursEl.textContent = pad(hours);
    if (minutesEl) minutesEl.textContent = pad(minutes);
    if (secondsEl) secondsEl.textContent = pad(seconds);
  };

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') {
      wasHidden = true;
      return;
    }
    if (document.visibilityState === 'visible' && wasHidden) {
      wasHidden = false;
      resetCountdown();
    }
  });

  window.addEventListener('pageshow', () => {
    resetCountdown();
  });

  tick();
  window.setInterval(tick, 1000);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fashion-home-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  const section = document.querySelector('[data-home-reviews]');
  if (!section) return;

  const track = section.querySelector('[data-reviews-track]');
  const slides = [...section.querySelectorAll('[data-reviews-slide]')];
  const prev = section.querySelector('[data-reviews-prev]');
  const next = section.querySelector('[data-reviews-next]');
  const dotsRoot = section.querySelector('[data-reviews-dots]');
  if (!track || slides.length === 0) return;

  let index = 0;

  const scrollToIndex = (i) => {
    index = (i + slides.length) % slides.length;
    const slide = slides[index];
    if (slide instanceof HTMLElement) {
      track.scrollTo({ left: Math.max(0, slide.offsetLeft), behavior: 'smooth' });
    }
    updateDots();
  };

  const updateDots = () => {
    if (!dotsRoot || slides.length < 2) return;
    dotsRoot.hidden = false;
    dotsRoot.innerHTML = '';
    slides.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'by-fashion-reviews__dot' + (i === index ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Ir a la reseña ' + (i + 1));
      dot.addEventListener('click', () => scrollToIndex(i));
      dotsRoot.appendChild(dot);
    });
  };

  prev?.addEventListener('click', () => scrollToIndex(index - 1));
  next?.addEventListener('click', () => scrollToIndex(index + 1));

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const i = slides.indexOf(entry.target);
        if (i >= 0) {
          index = i;
          updateDots();
        }
      });
    },
    { root: track.parentElement, threshold: 0.6 }
  );
  slides.forEach((s) => io.observe(s));
  updateDots();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fashion-home-social-videos"] && !Shopify.designMode) return;
  try {
    
(function () {
  const section = document.querySelector('[data-home-social-videos]');
  if (!section) return;

  const videos = section.querySelectorAll('video[data-lazy-video]');
  if (!videos.length) return;

  const primeFirstFrame = (video) => {
    const seek = () => {
      try {
        if (video.readyState >= 1 && video.currentTime === 0) {
          video.currentTime = 0.001;
        }
      } catch (e) {
        /* ignore seek errors on some browsers */
      }
    };
    video.addEventListener('loadedmetadata', seek, { once: true });
    video.addEventListener('loadeddata', seek, { once: true });
  };

  const attachSource = (video) => {
    if (video.dataset.attached === 'true') return;
    const src = video.getAttribute('data-src');
    if (!src) return;
    video.src = src;
    video.dataset.attached = 'true';
    primeFirstFrame(video);
    video.load();
  };

  const playWhenReady = (video) => {
    const tryPlay = () => {
      const p = video.play();
      if (p && typeof p.catch === 'function') p.catch(() => {});
    };
    if (video.readyState >= 2) {
      tryPlay();
    } else {
      video.addEventListener('canplay', tryPlay, { once: true });
    }
  };

  if (!('IntersectionObserver' in window)) {
    videos.forEach((video) => {
      attachSource(video);
      playWhenReady(video);
    });
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) {
          attachSource(video);
          playWhenReady(video);
        } else {
          video.pause();
        }
      });
    },
    { root: null, rootMargin: '80px 0px', threshold: 0.2 }
  );

  videos.forEach((video) => observer.observe(video));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["manay-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function init(root) {
      if (!root || root.dataset.carouselReady === 'true') return;
      var track = root.querySelector('[data-reviews-track]');
      var viewport = root.querySelector('[data-reviews-viewport]');
      var prev = root.querySelector('[data-reviews-prev]');
      var next = root.querySelector('[data-reviews-next]');
      var dotsWrap = root.querySelector('[data-reviews-dots]');
      if (!track || !viewport) return;

      var slides = Array.prototype.slice.call(
        track.querySelectorAll('.manay-reviews-carousel__slide')
      );
      var total = slides.length;
      if (!total) {
        root.hidden = true;
        return;
      }

      root.dataset.carouselReady = 'true';
      if (reduced) root.classList.add('is-reduced');

      var index = 0;
      var startX = 0;
      var deltaX = 0;
      var dragging = false;
      var swiped = false;

      function go(nextIndex, instant) {
        index = (nextIndex + total) % total;
        var useInstant = instant || reduced;
        if (useInstant) root.classList.add('is-reduced');
        track.style.transform = 'translateX(' + -index * 100 + '%)';
        slides.forEach(function (slide, i) {
          var active = i === index;
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        if (dotsWrap) {
          Array.prototype.forEach.call(dotsWrap.children, function (dot, i) {
            var active = i === index;
            dot.classList.toggle('is-active', active);
            dot.setAttribute('aria-current', active ? 'true' : 'false');
          });
        }
        if (useInstant && !reduced) {
          window.requestAnimationFrame(function () {
            root.classList.remove('is-reduced');
          });
        }
      }

      function renderDots() {
        if (!dotsWrap) return;
        dotsWrap.innerHTML = '';
        for (var i = 0; i < total; i++) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'manay-reviews-carousel__dot' + (i === index ? ' is-active' : '');
          btn.setAttribute('aria-label', 'Ir a la opinión ' + (i + 1));
          if (i === index) btn.setAttribute('aria-current', 'true');
          btn.addEventListener('click', (function (target) {
            return function () { go(target); };
          })(i));
          dotsWrap.appendChild(btn);
        }
      }

      if (prev) prev.addEventListener('click', function () { go(index - 1); });
      if (next) next.addEventListener('click', function () { go(index + 1); });

      viewport.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          go(index - 1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          go(index + 1);
        }
      });
      viewport.setAttribute('tabindex', '0');

      viewport.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        dragging = true;
        swiped = false;
        startX = event.clientX;
        deltaX = 0;
        root.classList.add('is-dragging');
        viewport.setPointerCapture(event.pointerId);
      });
      viewport.addEventListener('pointermove', function (event) {
        if (!dragging) return;
        deltaX = event.clientX - startX;
        var width = viewport.getBoundingClientRect().width || 1;
        track.style.transform =
          'translateX(' + ((-index * 100) + (deltaX / width) * 100) + '%)';
      });
      function endDrag() {
        if (!dragging) return;
        dragging = false;
        root.classList.remove('is-dragging');
        var width = viewport.getBoundingClientRect().width || 1;
        if (Math.abs(deltaX) > Math.min(40, width * 0.18)) {
          swiped = true;
          go(index + (deltaX < 0 ? 1 : -1));
        } else {
          go(index);
        }
        deltaX = 0;
      }
      viewport.addEventListener('click', function (event) {
        if (swiped) {
          event.preventDefault();
          event.stopPropagation();
          swiped = false;
        }
      }, true);
      viewport.addEventListener('pointerup', endDrag);
      viewport.addEventListener('pointercancel', endDrag);
      viewport.addEventListener('pointerleave', function () {
        if (dragging) endDrag();
      });

      renderDots();
      go(0, true);
    }

    function start() {
      document.querySelectorAll('[data-manay-reviews-carousel]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-manay-reviews-carousel]');
      if (root) {
        delete root.dataset.carouselReady;
        init(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
